// extracted by mini-css-extract-plugin
export var dividerContainer = "_7u-0";
export var line = "_7u-1";